import { INgsiAIS } from '../interfaces/ngsi/ais-interface';


export interface IObcInstrumentField {
	size?: string;
	setpoint: number;
	hasSetpoint: boolean;
	value: number;
	degree: boolean;
	maxDigits?: number;
	fractionDigits: number;
	tag: string;
	unit: string;
	source: string;
	hasSource: boolean;
	aisKey: keyof INgsiAIS;
}

export interface IDefaultObcNavInstruments {
	hdg: IObcInstrumentField
	rot: IObcInstrumentField
	cog: IObcInstrumentField
	sog: IObcInstrumentField
	mtw: IObcInstrumentField          // water temperatur
	depthMeters: IObcInstrumentField  // depth meters
	windDirTrue: IObcInstrumentField  // true wind directions
	windSpeedM: IObcInstrumentField   // true wind speed
}

export const DefaultObcNavInstruments: IDefaultObcNavInstruments = {
	hdg: {
		setpoint: 0,
		hasSetpoint: false,
		value: 0,
		degree: true,
		tag: 'HDG',
		unit: '',
		source: '',
		hasSource: false,
		fractionDigits: 1,
		aisKey: "hdg"
	},
	rot: {
		setpoint: 0,
		hasSetpoint: false,
		value: 0,
		degree: false,
		tag: 'ROT',
		unit: '°/min',
		source: '',
		hasSource: false,
		fractionDigits: 1,
		aisKey: "rot"
	},
	cog: {
		setpoint: 0,
		hasSetpoint: false,
		value: 0,
		degree: true,
		tag: 'COG',
		unit: '',
		source: '',
		hasSource: false,
		fractionDigits: 1,
		aisKey: "cog"
	},
	sog: {
		setpoint: 0,
		hasSetpoint: false,
		value: 0,
		degree: false,
		tag: 'SOG',
		unit: 'knots',
		source: '',
		hasSource: false,
		fractionDigits: 1,
		aisKey: "sog"
	},
	mtw: {
		setpoint: 0,
		hasSetpoint: false,
		value: 0,
		degree: true,
		tag: 'TMP',
		unit: '°C',
		source: '',
		hasSource: false,
		fractionDigits: 1,
		aisKey: "mtw"
	},
	depthMeters: {
		setpoint: 0,
		hasSetpoint: false,
		value: 0,
		degree: false,
		tag: 'DBT',
		unit: 'm',
		source: '',
		hasSource: false,
		fractionDigits: 1,
		aisKey: "depthMeters"
	},
	windDirTrue: {
		setpoint: 0,
		hasSetpoint: false,
		value: 0,
		degree: true,
		tag: 'TWD',
		unit: '',
		source: '',
		hasSource: false,
		fractionDigits: 1,
		aisKey: "windDirTrue"
	},
	windSpeedM: {
		setpoint: 0,
		hasSetpoint: false,
		value: 0,
		degree: false,
		tag: 'TWS',
		unit: 'm/s',
		source: '',
		hasSource: false,
		fractionDigits: 1,
		aisKey: "windSpeedM"
	}
};
